import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import { PrimaryButton } from "../../elements/Button";

type AdvertisersEmptyStateProps = {
  onNewAdvertiser: () => void;
};

const Root = styled("div")({
  padding: "56px 32px",
  textAlign: "center",
});

const IconWrap = styled("div")(({ theme }: { theme: Theme }) => ({
  width: 56,
  height: 56,
  borderRadius: 14,
  background: theme.palette.brand.gray100,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 16,
  border: `1px solid ${theme.palette.brand.gray200}`,
}));

const Title = styled("h3")(({ theme }: { theme: Theme }) => ({
  margin: 0,
  fontSize: 15,
  fontWeight: 600,
  color: theme.palette.brand.gray700,
}));

const Description = styled("p")(({ theme }: { theme: Theme }) => ({
  margin: "6px 0 20px",
  fontSize: 13,
  color: theme.palette.brand.gray500,
}));

const PlusIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const BuildingIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
  </svg>
);

const AdvertisersEmptyState: FC<AdvertisersEmptyStateProps> = ({ onNewAdvertiser }) => (
  <Root>
    <IconWrap>
      <BuildingIcon />
    </IconWrap>
    <Title>No advertisers yet</Title>
    <Description>Create your first advertiser account to start managing campaigns.</Description>
    <PrimaryButton type="button" onClick={onNewAdvertiser}>
      <PlusIcon />
      New Advertiser
    </PrimaryButton>
  </Root>
);

export default AdvertisersEmptyState;
